import Link from "next/link"
import richText from "utilities/richText"
import Modal from "components/Modal"
import useModal from "utilities/useModal"
import DynamicComponent from "components/DynamicComponent/index"
import MembershipForm from "components/MembershipForm"
import PricingChart from "./PricingChart"
import getStoryblokLink from "utilities/getStoryblokLink"

export default function PricingSection({ blok }) {
  const weeklyModalProps = useModal("enroll-weekly")
  const monthlyModalProps = useModal("enroll-monthly")

  return (
    <>
      <section className="py-12 px-8 max-w-screen-xl mx-auto">
        <div className="pricing-section-content text-white text-center prose-h1:pb-4">{richText(blok.intro_text)}</div>

        {blok.intro_links
          ? blok.intro_links.map((link) => (
              <div key={link.id} className="text-white text-center leading-none -my-2">
                <DynamicComponent blok={link} />{" "}
              </div>
            ))
          : null}
        <PricingChart
          columns={blok.columns}
          discount_banner={blok.discount_banner}
          pricing_download_link={blok.pricing_download_link}
          fine_print_text={blok.fine_print_text}
        />
      </section>
      <Modal {...weeklyModalProps}>
        <div className="bg-white py-4 lg:px-10">
          <h3 className="font-bold text-l1 text-center mb-2">{blok.title}</h3>
          <p className="font-bold text-m1 py-4">
            I acknowledge that I have read and agree to the following sections under{" "}
            <Link href="#important-details" className="text-green-pine underline hover:no-underline">
              Important Details:
            </Link>
          </p>
          <MembershipForm smartSheetLink={getStoryblokLink(blok.weekly_smartsheet_link)} />
        </div>
      </Modal>
      <Modal {...monthlyModalProps}>
        <div className="bg-white py-4 lg:px-10">
          <h3 className="font-bold text-l1 text-center mb-2">{blok.title}</h3>
          <p className="font-bold text-m1 py-4">
            I acknowledge that I have read and agree to the following sections under{" "}
            <Link href="#important-details" className="text-green-pine underline hover:no-underline">
              Important Details:
            </Link>
          </p>
          <MembershipForm smartSheetLink={getStoryblokLink(blok.monthly_smartsheet_link)} />
        </div>
      </Modal>
    </>
  )
}
